import { useState } from "react";

export default function CTASection() {
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!mobile || !email) return;
    console.log("Submitted:", { mobile, email });
    setSubmitted(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <section className="cta">
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
          <span style={{ width: "32px", height: "2px", backgroundColor: "#c0532f" }} />
          <span
            style={{
              color: "#c0532f",
              fontSize: "13px",
              letterSpacing: "3px",
              fontWeight: 500,
            }}
          >
            ADMISSIONS OPEN
          </span>
        </div>

        <h1
          style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: "clamp(2.1rem, 4vw, 3.5rem)",
            lineHeight: 1.15,
            color: "#1a1a1a",
            margin: 0,
            fontWeight: 500,
          }}
        >
          Ready to Build Your
          <br />
          <span style={{ fontStyle: "italic", color: "#c0532f", fontWeight: "500" }}>Design Career?</span>
        </h1>

        <p style={{ color: "#6b6b6b", fontSize: "15px", lineHeight: 1.6, marginTop: "24px", maxWidth: "560px" }}>
          Enter your details and our team will get back to you to guide you through the program.
          New batch enrolling for 2026 — limited seats available.
        </p>
      </div>

      <div className="cta-form-w">
        {submitted ? (
          <div
            style={{
              fontFamily: "Arial, sans-serif",
              fontSize: "15px",
              color: "#1a1a1a",
              padding: "14px 0",
            }}
          >
            Thanks! We'll reach out to you shortly.
          </div>
        ) : (
          <div className="cta-form">
            <input
              type="tel"
              placeholder="Your mobile number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              onKeyDown={handleKeyDown}
              className="cta-inp"
            />
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              className="cta-inp"
            />
            <button onClick={handleSubmit} className="cta-btn">
              Submit
            </button>
          </div>
        )}

        {/* <div className="cta-contact">
          Call: <a href="tel:+919860598605">+91 98605 98605</a> · <a href="mailto:info@ipdi.in">info@ipdi.in</a>
        </div> */}
      </div>
    </section>
  );
}
